import { defineTransform, JsonResponse, Nullable } from '@client/core/data/concerns/parses-from-json';
import { parseISO } from '@client/core/utils/date';

export class MlsHistory {
  constructor(
    public readonly daysOnMarket: Nullable<number>,
    public readonly isEstimateSalePrice: Nullable<boolean>,
    public readonly listingDate: Nullable<Date>,
    public readonly listingStatus: Nullable<string>,
    public readonly minListPrice: Nullable<number>,
    public readonly maxListPrice: Nullable<number>,
    public readonly mlsNumber: Nullable<string>,
    public readonly soldDate: Nullable<Date>,
    public readonly soldPrice: Nullable<number>,
    public readonly statusType: Nullable<string>,
  ) {}
}

defineTransform(MlsHistory, (json: JsonResponse, { fromSnakeCaseKeys, nullOr }) => {
  return {
    ...fromSnakeCaseKeys(),
    daysOnMarket: nullOr(json.days_on_market, () => parseInt(json.days_on_market)),
    listingDate: nullOr(json.listing_date, () => parseISO(json.listing_date)),
    minListPrice: nullOr(json.min_list_price, () => parseFloat(json.min_list_price)),
    maxListPrice: nullOr(json.max_list_price, () => parseFloat(json.max_list_price)),
    soldDate: nullOr(json.sold_date, () => parseISO(json.sold_date)),
    soldPrice: nullOr(json.sold_price, () => parseFloat(json.sold_price)),
  };
});
